import { Component } from '@ecs/Component';

export class ScoreValue implements Component {
  readonly type = 'ScoreValue';

  constructor(
    public points: number = 100
  ) {}
}
